import triggersService from '../../services/triggersService'

class TriggersController {
  createTrigger = triggersService.createTrigger
}

export default new TriggersController()



// WEBPACK FOOTER //
// ../src/controllers/triggersController/triggersController.js